<template>
    <div>
    <Visibility @visibility="visibility" />
    <ApprovalLevel @approvalLevel="approvalLevel" />
    </div>
</template>
<script>
import Visibility from './Visibility';
import ApprovalLevel from './ApprovalLevel';
export default {
         name: "Action",
         components: {
            Visibility,
            ApprovalLevel,
         },
         data() {
           return {
           }
         },
         methods:{
            visibility(val){
                console.log(val,"visibility emitted value is here");
            },
            approvalLevel(val) {
                console.log(val,"approvalLevel emitted value is here");
            },
         },
       }
</script>
<style scoped>
</style>